<script lang="ts" setup>
import { ref, onMounted } from "vue";
import { useAuthorizedDeviceStore } from "~/stores/use-authorieze-device-store";

const isClient = ref(false);
const authDevice = useAuthorizedDeviceStore();
const route = useRoute();

onMounted(() => {
  isClient.value = true;
  console.log(route.name);
});
</script>

<template>
  <div
    v-if="
      isClient &&
      authDevice.user &&
      !authDevice.user.authorized_device &&
      route.name !== 'verificacion-dos-pasos'
    "
    class="container-fluid"
  >
    <div class="row custom-badge badge-red text-ce">
      <a
        class="text-center text-decoration-none text-normal text-danger"
        href="/verificacion-dos-pasos"
      >
        Dispositivo no autorizado. Haz click aquí para verificarlo
      </a>
    </div>
  </div>
</template>
